import { IEndFlowChain } from './EndFlowChain'

/**
 * An interface that represents an EndFlowManager.
 */
export interface IEndFlowManager {
    massage_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        price: string
        serviceDate: string
        firstName: string
    }>
    training_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        price: string
        serviceDate: string
        firstName: string
    }>
    yoga_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        price: string
        serviceDate: string
        firstName: string
    }>
    company_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        price: string
        serviceDate: string
        firstName: string
    }>
    companyLead_chain: IEndFlowChain<{
        firstName: string
    }>
    package_chain: IEndFlowChain<{
        address: string
        customerType: string
        basisTypeId: number
        goalId: number
        serviceTypeId: number
        profileId: number
        customerName: string
        customerPhone: number
        customerEmail: string
    }>
    edit_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        serviceDate: string
    }>
    cancellation_chain: IEndFlowChain<void>
}

/**
 * EndFlowManager is an abstarc class that defines the structure of an EndFlowManager.
 * Each EndFlowManager must have a number of middleware chain handlers.
 * Each middleware chain handler is a chain of functions that are executed one after the other.
 * @example const manager = new EndFlowManager();
 * @example manager.massage_chain.use([func1, func2, func3]);
 * @example manager.massage_chain.do(data);
 * @example manager.massage_chain.do(data1, data2);
 * @example manager.training_chain.use([func4, func5]);
 */
export abstract class EndFlowManager implements IEndFlowManager {
    abstract massage_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        price: string
        serviceDate: string
        firstName: string
    }>
    abstract training_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        price: string
        serviceDate: string
        firstName: string
    }>
    abstract yoga_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        price: string
        serviceDate: string
        firstName: string
    }>
    abstract company_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        price: string
        serviceDate: string
        firstName: string
    }>
    abstract companyLead_chain: IEndFlowChain<{
        firstName: string
    }>
    abstract package_chain: IEndFlowChain<{
        address: string
        customerType: string
        basisTypeId: number
        goalId: number
        serviceTypeId: number
        profileId: number
        customerName: string
        customerPhone: number
        customerEmail: string
    }>
    abstract edit_chain: IEndFlowChain<{
        serviceName: string
        partnerType: string
        alias: string
        serviceDate: string
    }>
    abstract cancellation_chain: IEndFlowChain<void>
}
